import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readByName: (name, groupName) =>
    api
      .send({
        query: gql`
          query READ_BY_NAME($name: String!, $groupName: String!) {
            Event {
              readByName(name: $name, groupName: $groupName) {
                _id
                name
                path
              }
            }
          }
        `,
        variables: { name, groupName }
      })
      .then(result => result.data.data.Event.readByName)
}
